// @ts-nocheck
/**
 * Higher-Order Component for Drag and Drop functionality
 * @module hoc/withDragDrop
 */

import React from 'react';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';

/**
 * HOC that adds drag and drop functionality to a component
 * @param {React.Component} WrappedComponent - The component to wrap with drag and drop
 * @returns {React.Component} - Component with drag and drop functionality
 */
const withDragDrop = (WrappedComponent) => {
  const DragDropConnector = (props) => {
    const { DropTarget, DragSource } = props.reactDnd;

    const DndConnectedComponent = React.useMemo(
      () =>
        DropTarget(
          'item',
          {
            hover(props, monitor) {
              const id = monitor.getItem().id;
              const dragOrder = monitor.getItem().order;
              const hoverOrder = props.order;

              if (dragOrder === hoverOrder) {
                return;
              }

              props.onOrderItem(id, dragOrder, hoverOrder - dragOrder, false);

              monitor.getItem().order = hoverOrder;
            },
            drop(props, monitor) {
              const id = monitor.getItem().id;
              const dragOrder = monitor.getItem().startOrder;
              const dropOrder = props.order;

              if (dragOrder === dropOrder) {
                return;
              }

              props.onOrderItem(id, dragOrder, dropOrder - dragOrder, true);

              monitor.getItem().order = dropOrder;
            },
          },
          (connect) => ({
            connectDropTarget: connect.dropTarget(),
          }),
        )(
          DragSource(
            'item',
            {
              beginDrag(props) {
                return {
                  id: props.item['@id'],
                  order: props.order,
                  startOrder: props.order,
                };
              },
            },
            (connect, monitor) => ({
              connectDragSource: connect.dragSource(),
              connectDragPreview: connect.dragPreview(),
              isDragging: monitor.isDragging(),
            }),
          )(WrappedComponent),
        ),
      [DragSource, DropTarget],
    );

    return <DndConnectedComponent {...props} />;
  };

  return injectLazyLibs('reactDnd')(DragDropConnector);
};

export default withDragDrop;
